import React, { useState } from "react";
import ReusableSidebar from "../../components/sidebar/reusable-sidebar";
import { useUser } from "../../services/contexts/user-context";
import { MainContent } from "../../components/sidebar/sidebar.styles";
import Loading from "../../components/loading";
import SettingsPage from "../../shared-views/settings/settings-page";

const RecruiterSettings = () => {
  const { user, isLoading } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() =>
    typeof window === 'undefined' || !window.matchMedia('(max-width: 768px)').matches
  );

  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <ReusableSidebar
        isSidebarOpen={isSidebarOpen}
        handleToggleSidebar={handleToggleSidebar}
        selectedPage="settings"
        user={user}
        loading={isLoading}
      />

      <MainContent isSidebarOpen={isSidebarOpen}>
        {isLoading ? <Loading /> : <SettingsPage role="recruiter" />}
      </MainContent>
    </>
  );
};

export default RecruiterSettings;
